<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="150"
          height="150"
          class="iconMargin"
          src="../assets/knee.jpg"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>

    <p class="paragraph">
      <b>{{ opis2 }}</b>
    </p>
    <li class="paragraph2" v-for="item in list" :key="item.index">
      {{ item }}
    </li>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Fizjoterapia ortopedyczna",
      opis1:
        "Fizjoterapia ortopedyczna związana jest z urazami narządu ruchu w obrębie kości, stawów oraz tkanek miękkich. Zajmuje się leczeniem dolegliwości bólowych i dysfunkcji stawów, ścięgien i mięśni wynikających zarówno z przeciążeń, jak i urazów. Celem fizjoterapii ortopedycznej jest odzyskanie pełnej sprawności pacjenta, jej utrzymanie oraz prewencję przed nawrotem urazu. Zawiera pełną diagnostykę fizjoterapeutyczną pacjenta oraz wskazanie kompleksowej terapii z wykorzystaniem metod specjalnych. Kompleksowa terapia opiera się na terapii manualnej i zindywidualizowanym programie ćwiczeń. Takie postępowanie ma na celu pełny powrót pacjenta do codziennych aktywności, a także do uprawianej dyscypliny sportu. Stosowane w trakcie rehabilitacji metody specjalne dobierane są w sposób indywidualny dla każdego Pacjenta.",
      opis2: "Fizjoterapia ortopedyczna obejmuje:",
      list: [
        "usprawnianie pacjentów ortopedycznych,",
        "dolegliwości bólowe kręgosłupa i stawów obwodowych,",
        "zaburzenia posturalne, kręgozmyk, ",
        "dysfunkcje narządu ruchu,",
        "napięciowe bóle głowy, migreny, nerwobóle,",
        "stany przeciążeniowe mięśni i stawów,",
        "wady postawy ciała,",
        "urazy i kontuzje,",
        "zawroty głowy, bezsenność, chroniczne zmęczenie.",
      ],
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.paragraph3 {
  text-align: justify;
  text-align-last: left;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>